<svg
	viewBox="0 0 12 12"
	width="12"
	height="12"
	fill="currentColor"
    class="inline" {...$$restProps}
	xmlns="http://www.w3.org/2000/svg"
	{...$$restProps}
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M2.91309 2.08628L7.15609 6.32828C7.54666 6.71876 8.17983 6.71869 8.57031 6.32812C8.96079 5.93755 8.96071 5.30438 8.57014 4.9139L4.32714 0.671904C3.93657 0.281425 3.30341 0.2815 2.91293 0.67207C2.52245 1.06264 2.52252 1.69581 2.91309 2.08628Z"
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M7.15599 4.91417L2.91399 9.15617C2.52346 9.5467 2.52346 10.1799 2.91399 10.5704C3.30451 10.9609 3.93768 10.9609 4.3282 10.5704L8.5702 6.32839C8.96072 5.93786 8.96072 5.3047 8.5702 4.91417C8.17968 4.52365 7.54651 4.52365 7.15599 4.91417Z"
	/>
</svg>